import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import {
  ContentContainer,
  PageWrapper,
  BannerSpacer,
  SiteSelectorWrapper,
} from './component.styles'

import HighSchoolPreviewBanner from 'components/HighSchoolPreviewBanner'
import SubLandingBanner from 'experienceComponents/SubLandingBanner'
import ContentCallout from 'experienceComponents/ContentCallout'
import SiteSelector from 'components/SiteSelector'
import HighSchoolTrainingLinkSummaries from './HighSchoolTrainingLinkSummaries'

const TrainingLandingV3 = ({
  articles = [],
  banner,
  hsLinkSummaries = [],
  isHsLanding = false,
  isHsPreview,
  instructorData,
  navigationEvent,
  pageType,
  productTabTitle,
  shouldShowSiteSelector,
}) => {
  useEffect(() => {
    const { title } = banner || {}
    if (title && productTabTitle) {
      document.title = `${productTabTitle} | ${title}`
    }
  }, [banner, productTabTitle])

  const filteredArticles = articles.filter(
    article => article.body && article.title,
  )

  return (
    <PageWrapper>
      {isHsPreview && (
        <>
          <BannerSpacer />
          <HighSchoolPreviewBanner />
        </>
      )}

      {shouldShowSiteSelector && (
        <SiteSelectorWrapper>
          <SiteSelector />
        </SiteSelectorWrapper>
      )}

      <SubLandingBanner
        key="banner"
        navigateToDashboardOnClick={() => navigationEvent('/dashboard')}
        pageType={pageType}
        shouldShowSiteSelector={false}
        {...banner}
      />

      <ContentContainer>
        {isHsLanding ? (
          <HighSchoolTrainingLinkSummaries
            instructorData={instructorData}
            linkSummaries={hsLinkSummaries}
          />
        ) : (
          filteredArticles.map((article, index) => {
            const uniqueId = `article-${index + 1}`
            return (
              <ContentCallout
                {...article}
                dataTestId={uniqueId}
                isHsPreview={isHsPreview}
                key={uniqueId}
              />
            )
          })
        )}
      </ContentContainer>
    </PageWrapper>
  )
}

TrainingLandingV3.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.object),
  banner: PropTypes.object,
  hsLinkSummaries: PropTypes.arrayOf(PropTypes.object),
  instructorData: PropTypes.object,
  isHsLanding: PropTypes.bool,
  isHsPreview: PropTypes.bool,
  navigationEvent: PropTypes.func,
  pageType: PropTypes.string,
  productTabTitle: PropTypes.string,
  shouldShowSiteSelector: PropTypes.bool,
}

export default TrainingLandingV3
